// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57662b96","507":"b873a03f","801":"d14eb511"}[chunkId] + ".chunk.js";
};